import { EnvironmentPlugin } from "webpack";

    
export function init(widget: HTMLElement) {

  const input      = widget.querySelector('.select-input')                as HTMLInputElement;
  const checkboxes = Array.from(widget.querySelectorAll('li input'))      as HTMLInputElement[];
  const labels     = Array.from(widget.querySelectorAll('li label'))      as HTMLLabelElement[];
  const button     = widget.querySelector('.select-button')               as HTMLButtonElement;
  const body       = Array.from(document.getElementsByTagName('body'))[0] as HTMLBodyElement;
  const container  = widget.querySelector('.select-container')            as HTMLElement;
  const info       = widget.querySelector('.select-info')                 as HTMLElement;
  
  updateSelectionInfo(widget);

  // Text search
  input.addEventListener('keyup', updateTextSelection);

  function updateTextSelection(this: HTMLInputElement, event: KeyboardEvent) {
    const searchText = this.value;

    const notSelectedLabels = 
      labels.filter(label => label.textContent.toLowerCase().indexOf(searchText.toLowerCase()) == -1);

    const selectedLabels = 
      labels.filter(label => label.textContent.toLowerCase().indexOf(searchText.toLowerCase()) != -1);

    for (const label of notSelectedLabels) {
      label.parentElement.style.display = 'none';
    }
    for (const label of selectedLabels) {
      label.parentElement.style.display = 'list-item';
    }
  }

  // Menu open / close
  body     .addEventListener('multiSelectEvent', ((event: CustomEvent) => closeMenu(event)) as EventListener);
  body     .addEventListener('click', event => closeMenu(event));
  button   .addEventListener('click', event => toggleMenu(event));
  info     .addEventListener('click', event => toggleMenu(event));
  container.addEventListener('click', event => event.stopPropagation());

  function toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    const multiSelectEvent = new CustomEvent('multiSelectEvent', {
      bubbles: true,
      detail: widget.id,
    });
    widget.dispatchEvent(multiSelectEvent);

    container.classList.toggle('select-closed');
    button.classList.toggle('select-closed');
  }

  function closeMenu(event: CustomEvent | MouseEvent) {

    // Do not close own menu
    if (event.type == 'multiSelectEvent' && event.detail == widget.id) return;

    container.classList.add('select-closed');
    button.classList.add('select-closed');
  }

  // Click checkbox
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('click', event => {
      event.stopPropagation();

      const checkboxEvent = new CustomEvent('checkboxEvent', {
        bubbles: true,
        detail: {
          id: checkbox.id.replace('checkbox-', ''),
        }
      });
      widget.dispatchEvent(checkboxEvent);

      updateSelectionInfo(widget);
    });
  });

  // Browser would jump to element before scrolling per default. 
  // Prevent this behaviour.
  labels.forEach(label => {
    label.addEventListener('click', event => {
      (label.parentElement.firstElementChild as HTMLInputElement).click();
      event.preventDefault();
    });
  });

}


function updateSelectionInfo(widget: HTMLElement) {

  const infoElement = widget.querySelector('.select-info')       as HTMLElement;
  const infoText    = widget.querySelector('.select-info-text')  as HTMLElement;
  const infoCount   = widget.querySelector('.select-info-count') as HTMLElement;
  const items       = Array.from(widget.querySelectorAll('li'));

  const selectedLabels = items
    .filter(item => item.querySelector('input').checked)
    .map   (item => item.querySelector('label').innerHTML);

  // Only labels up to 25 characters in total.
  const displayedLabels = selectedLabels
    .reduce((items, item) => {
      const punctuation = items.length * 2;
      const textLength  = items.join('').length;
      return (textLength + punctuation + item.length < 25) ? [...items, item] : items
    },[]);

  const remainingCounter = selectedLabels.length - displayedLabels.length;
  const text             = displayedLabels.join(', ');
  const counterText      = '+' + remainingCounter.toString();

  infoText.innerHTML =
    (displayedLabels.length > 0) ? text : infoElement.dataset.empty;

  infoCount.innerHTML = 
    (remainingCounter > 0) ? counterText : '';

  if (displayedLabels.length > 0) {
    widget.classList.add('select-used');
  }
  else {
    widget.classList.remove('select-used');
  }
}

/**
 * Activates / deactivates items
 */
export function updateItemState(id: string, isActive: boolean, checked: boolean) {
  const checkbox = document.getElementById('checkbox-' + id) as HTMLInputElement;
  const label    = document.getElementById('label-' + id)    as HTMLElement;

  checkbox.checked = checked;

  if (isActive) {
    checkbox.disabled = false;
    label.classList.remove('inactive');
  }
  else {
    checkbox.disabled = true;
    label.classList.add('inactive');
  }
}